import { FaGithub, FaLinkedin } from "react-icons/fa6";
import {
  PROFILE_PIC_LINK,
  NAME,
  JOB_TITLE,
  LOCATION,
  STATUS,
  INTRO,
  RESUME_LINK,
  GITHUB_LINK,
  LINKEDIN_LINK,
  EMAIL,
  PERSONAL_SITE,
  PERSONAL_SITE_LABEL,
} from "../data/ResumeData";

function Profile() {
  return (
    <header>
      {/* Top row: avatar + name block + resume CTA */}
      <div className="flex items-start gap-5 sm:gap-6">
        {/* Portrait */}
        <div className="shrink-0">
          <div className="h-[88px] w-[88px] sm:h-[100px] sm:w-[100px] overflow-hidden rounded-full border border-rule bg-bg-recessed">
            <img
              src={PROFILE_PIC_LINK}
              alt={`Portrait of ${NAME}`}
              className="h-full w-full object-cover"
              loading="eager"
            />
          </div>
        </div>

        {/* Name + role */}
        <div className="min-w-0 flex-1 pt-1">
          <h1
            className="font-display leading-[1.05]"
            style={{ fontSize: "var(--display-1)" }}
          >
            {NAME}
            <span aria-hidden="true" className="text-accent">.</span>
          </h1>

          <p className="mt-1 text-fg-muted text-[14.5px]">
            {JOB_TITLE}
          </p>

          <div className="mt-1.5 flex items-center gap-3 text-[13px] text-fg-subtle">
            <span>{LOCATION}</span>
            <span aria-hidden="true" className="text-fg-subtle/50">·</span>
            <span className="inline-flex items-center gap-1.5">
              <span className="relative flex h-1.5 w-1.5 shrink-0">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-60" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-accent" />
              </span>
              <span className="text-fg-muted">{STATUS}</span>
            </span>
          </div>
        </div>

        {/* Resume CTA — desktop */}
        <a
          href={RESUME_LINK}
          target="_blank"
          rel="noreferrer"
          className="hidden sm:inline-flex shrink-0 items-center gap-1.5 self-start mt-1 rounded-lg bg-accent text-accent-fg px-3.5 py-1.5 text-[12.5px] font-medium hover:bg-accent-soft transition-colors"
        >
          Résumé
          <span aria-hidden="true">↗</span>
        </a>
      </div>

      {/* Intro — two short paragraphs from the resume profile */}
      <div className="mt-4 sm:mt-5 space-y-2.5 text-[14.5px] leading-[1.55] text-fg-muted">
        {INTRO.map((para, i) => (
          <p key={i}>{para}</p>
        ))}
      </div>

      {/* Links row */}
      <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2">
        <a
          href={GITHUB_LINK}
          target="_blank"
          rel="noreferrer"
          aria-label="GitHub"
          className="text-fg-muted hover:text-accent transition-colors"
        >
          <FaGithub className="text-[18px]" />
        </a>
        <a
          href={LINKEDIN_LINK}
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
          className="text-fg-muted hover:text-accent transition-colors"
        >
          <FaLinkedin className="text-[18px]" />
        </a>
        <a
          href={`mailto:${EMAIL}`}
          className="text-[13px] text-fg-muted hover:text-accent transition-colors break-all"
        >
          {EMAIL}
        </a>
        <a
          href={PERSONAL_SITE}
          target="_blank"
          rel="noreferrer"
          className="text-[13px] text-fg-muted hover:text-accent transition-colors"
        >
          {PERSONAL_SITE_LABEL}
        </a>
        <a
          href={RESUME_LINK}
          target="_blank"
          rel="noreferrer"
          className="sm:hidden ml-auto inline-flex items-center gap-1.5 rounded-lg bg-accent text-accent-fg px-3.5 py-1.5 text-[12.5px] font-medium hover:bg-accent-soft transition-colors"
        >
          Résumé
          <span aria-hidden="true">↗</span>
        </a>
      </div>
    </header>
  );
}

export default Profile;
